"use client";

import { useEffect } from "react";

const THEME_KEY = "lightbird-theme";

function preferredTheme() {
  if (typeof window === "undefined") {
    return "light";
  }

  const stored = window.localStorage.getItem(THEME_KEY);

  if (stored === "dark" || stored === "light") {
    return stored;
  }

  return "light";
}

export function applyTheme(theme: "dark" | "light") {
  document.documentElement.classList.toggle("dark", theme === "dark");
  document.documentElement.dataset.theme = theme;
  window.localStorage.setItem(THEME_KEY, theme);
}

export function currentTheme() {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    applyTheme(preferredTheme() as "dark" | "light");
  }, []);

  return children;
}
